import { style } from "@vanilla-extract/css";
import { cellStyles, columnStyles } from "plos/src/components/Table/tables.css";
import { vars } from "plos/src/styles/theme.css";

export const upcomingContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const countdownSection = style({
  marginBottom: vars.space.m,
});

export const eventNameCol = style([
  columnStyles,
  {
    width: "50%",
  },
]);

export const deadlineCol = style([
  columnStyles,
  {
    width: "50%",
  },
]);

export const deadlineCell = style([
  cellStyles,
  {
    padding: `${vars.space.s} ${vars.space.xs}`,
  },
]);

export const eventNameCell = style([
  deadlineCell,
  {
    fontFamily: vars.fonts.bold,
  },
]);
